import store from "../app/store";

/**
 * Sends training data to the backend to train a bot.
 *
 * Endpoint: POST `/train/train_bot`
 *
 * @async
 * @function TrainBotOnData
 * @param {Object} data - The training payload containing:
 * @param {string} data.type - Type of the content (e.g., "html", "pdf", "text").
 * @param {string} data.subtype - Subtype for further classification (e.g., "web", "s3").
 * @param {string[]} data.list - Array of URLs or data items to be used for training.
 * @param {string} data.bot_id - Unique identifier of the bot to be trained.
 * @returns {Promise<{
 *   success: boolean,
 *   message?: string
 * }>} A promise that resolves to:
 * - `success`: Whether the training request was successful.
 * - `message`: Optional message in case of failure.
 *
 * @example
 * const result = await TrainBotOnData({
 *   type: "html",
 *   subtype: "web",
 *   list: ["https://example.com/page1", "https://example.com/page2"],
 *   bot_id: "69f034fa-b53e-4c69-8b7d-bc7b87b67270"
 * });
 *
 * if (result.success) {
 *   console.log("Bot training initiated.");
 * } else {
 *   console.error("Training failed:", result.message);
 * }
 */

const TrainBotOnData = async (data) => {
  const domain = process.env.REACT_APP_SERVER;
  const url = `${domain}/train/train_bot`;

  const token = store.getState().auth.token;

  if (!token) {
    return { data: null, error: "No token found" };
  }
  const option = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  };

  const res = await fetch(url, option);
  if (res.status === 200) {
    return true;
  } else {
    return false;
  }
};

export default TrainBotOnData;
